export const GAME_LAUNCH_BONUS_RECOVERY_EVENT =
  "crypto-game-launch-bonus-recovery";

const normalizeAllowedTypes = (allowedTypes = []) => {
  if (Array.isArray(allowedTypes)) {
    return allowedTypes
      .map((type) => String(type || "").toUpperCase())
      .filter(Boolean);
  }
  if (allowedTypes == null) return [];
  return [String(allowedTypes).toUpperCase()].filter(Boolean);
};

export const mapAllowedTypesToBonusGameType = (allowedTypes = []) => {
  const normalized = normalizeAllowedTypes(allowedTypes);
  const baseTypes = [
    ...new Set(
      normalized
        .map((type) => {
          if (type.startsWith("SPORTS_")) return "sport";
          if (type === "LIVE") return "live";
          if (type === "SLOT") return "slots";
          if (type === "MINIGAME") return "minigames";
          return null;
        })
        .filter(Boolean)
    ),
  ];

  if (baseTypes.length === 0) return "sport";
  if (baseTypes.length > 1) return "two_types";
  return baseTypes[0];
};

export const extractBonusRecoveryGate = (response) => {
  const data = response?.data;
  if (data?.is_playable !== false) return null;

  const allowedTypes = normalizeAllowedTypes(
    data?.game_specific_usage_settings_type
  );

  return {
    actionType:
      String(data?.bonus_recovery_action_type || "RECOVER").toUpperCase() ===
      "BLOCK"
        ? "BLOCK"
        : "RECOVER",
    allowedTypes,
    bonusGames: mapAllowedTypesToBonusGameType(allowedTypes),
  };
};
